import React from 'react';
import Styled from '../../styles/public/FVHeader.styled';
import LogoHumaneWhite from '../../../../images/logo/logo-humane-white.svg';
import { IFVHeader } from 'pages/ferramentaVideo/interfaces/components/IFVHeader';
import { YellowButton } from 'components/UI/Buttons';
import { IsCustomMaxWidth } from 'core/util/WindowSize';

const FVHeader = ({ buttonBack, onClickBack }: IFVHeader) => {

    const isMax700px = IsCustomMaxWidth(700);


    return (
        <Styled.Container>
            <Styled.Content>
                <img src={LogoHumaneWhite} alt="Logo Humane" />
                {!buttonBack && !isMax700px && (
                    <YellowButton
                        style={{
                            height: '48px',
                            minHeight: '48px',
                            maxWidth: '200px',
                            textTransform: 'uppercase',
                            borderRadius: '8px',
                            fontSize: '20px',
                        }}
                        onClick={onClickBack}
                        aria-label="Sair da ferramenta de videos"
                    >
                        Sair
                    </YellowButton>
                )}
            </Styled.Content>
        </Styled.Container>
    );
};

export default FVHeader;
